module.exports = __webpack_public_path__ + "static/media/RequestDemoBg@2x.2c11097a.png";